var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31521 11.1652L2.31507 5.16502L5.16502 2.31507L11.1652 8.31521C11.2478 8.39791 11.3064 8.50144 11.335 8.61479L12 12L8.61544 11.335C8.5018 11.3066 8.39785 11.2478 8.31521 11.1652ZM0.378082 3.22803C0.135997 2.98588 0 2.65748 0 2.31507C0 1.97266 0.135997 1.64426 0.378082 1.4021L1.4021 0.378082C1.64426 0.135996 1.97266 0 2.31507 0C2.65748 0 2.98588 0.135996 3.22803 0.378082L4.25206 1.4021L1.4021 4.25205L0.378082 3.22803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.56b446d297bbfa1a48a5d3df43a9b4c0.svg";
export { ForwardRef as ReactComponent };